<template>
  <div class="fixed inset-0 z-50 flex items-end justify-center md:items-start md:top-1/10">
    <div data-modal-close data-modal-overlay tabindex="-1" data-class-in="opacity-50" data-class-out="opacity-0" class="fixed inset-0 z-40 w-full transition-opacity duration-300 bg-black opacity-0 select-none"></div>

    <div
      data-modal-wrapper
      data-class-in="opacity-100 translate-y-0"
      data-class-out="opacity-0 translate-y-5"
      class="z-50 w-full max-w-[60rem] max-h-[31.625rem] scrolling-touch transition-all duration-300 transform translate-y-5 bg-white shadow-xl opacity-0 rounded-b-none rounded-t-xl md:rounded-xl overflow-hidden">
      <div class="flex h-full max-h-[31.625rem]">
        <!-- Modal image desktop -->
        <div v-if="hasImage" class="flex-1 hidden overflow-hidden md:block">
          <img width="40" height="40" class="inline object-cover w-full h-full ml-0" :src="params.imageUrl" />
        </div>

        <!-- Modal content area -->
        <div class="flex-1 p-6">
          <!-- Modal head -->
          <div class="flex justify-between pb-2 mb-4 border-b border-newColors-gray-baseB">
            <h2 v-if="hasImage" class="text-xl">{{ params.modalInfo }}</h2>
            <h2 v-if="!hasImage" class="text-xl">{{ params.heading }}</h2>
            <button data-modal-close aria-label="Close" class="flex items-center gap-2 text-lg font-futuraEfBook text-newColors-gray-contentA">
              <img width="14" height="14" class="inline ml-0" src="@/assets/images/cross-black.svg" alt="" /><span class="sr-only md:relative md:m-0 md:w-auto md:h-auto">{{ params.closeButton }}</span>
            </button>
          </div>

          <div class="max-h-full">
            <!-- Modal heading -->
            <h3 v-if="hasImage" class="mb-4 text-3xl">{{ params.heading }}</h3>

            <div class="modal-content-text">
              <!-- Modal image mobile -->
              <img v-if="hasImage" width="40" height="40" class="block object-cover w-full h-full mb-6 ml-0 md:hidden rounded-xl" :src="params.imageUrl" />

              <!-- Modal text -->
              <div v-html="params.content" class="text-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ellevio-web-modal-image-and-text',
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hasImage: false
    }
  },
  mounted() {
    this.hasImage = this.params.imageUrl ? true : false
  },
  methods: {}
}
</script>

<style scoped>
.modal-content-text {
  max-height: calc(31.625rem - 8.25rem);
  overflow: auto;
  @apply md:max-h-[50vh];
}

:deep(.modal-content-text p) {
  margin-bottom: 1.5rem;
}

:deep(.modal-content-text a) {
  text-decoration: underline;
}

:deep(.modal-content-text p:last-child) {
  margin-bottom: 0;
}
</style>
